<template>
  <div id="tradedataContains" class="tradedata-contains">
    <Header />
    <div class="main-outer">
      <Left />
      <Center />
      <Right />
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import Header from './components/Header/index.vue'
import Left from './components/Left/index.vue'
import Right from './components/Right/index.vue'
import Center from './components/Center/index.vue'
import autofit from 'autofit.js'

export default {
  components: {
    Header,
    Left,
    Right,
    Center,
  },

  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['siteInfo','selectLocId'])
  },
  watch:{
    selectLocId(){
      this.getStatis()
    }
  },
  created() {
    this.getStatis()
  },
  mounted(){
    // 自适应大屏尺寸
    autofit.init({
        dh: 919,
        dw: 1920,
        el:"#tradedataContains",
        resize: true,
    })
  },
  methods: {
    ...mapActions({
      getStatis:  'bigdata/getStatis'
    })
  }
}
</script>

<style lang="scss" scoped>
.tradedata-contains {
  height: 100%;
  background: url('~@/assets/images/tradedata-bg.png') center center / cover no-repeat;
  --color:#2EF3FF;
  .main-outer{
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
  }
}
</style>
